/* ===== Veratex Fabrics theme JS ===== */
(function(){
  "use strict";

  function $(s, c){ return (c||document).querySelector(s); }
  function $all(s, c){ return Array.prototype.slice.call((c||document).querySelectorAll(s)); }

  function toast(msg){
    var t = $("#toast"); if(!t) return;
    t.textContent = msg; t.classList.add("show");
    clearTimeout(t._timer);
    t._timer = setTimeout(function(){ t.classList.remove("show"); }, 2000);
  }
  window.vxToast = toast;

  function refreshCart(){
    fetch("/cart.js", { headers:{ "Accept":"application/json" } })
      .then(function(r){ return r.json(); })
      .then(function(c){
        $all(".bag-count").forEach(function(el){ el.textContent = c.item_count; });
      }).catch(function(){});
  }
  window.vxRefreshCart = refreshCart;

  var dd = $("#HeaderDropdown");
  if(dd){
    var ddBtn = $(".dd-btn", dd);
    if(ddBtn){
      ddBtn.addEventListener("click", function(e){ e.stopPropagation(); dd.classList.toggle("open"); });
      document.addEventListener("click", function(){ dd.classList.remove("open"); });
    }
  }

  var mnav = $("#MobileNav");
  function openMobile(){ if(mnav){ mnav.classList.add("open"); document.body.style.overflow="hidden"; } }
  function closeMobile(){ if(mnav){ mnav.classList.remove("open"); document.body.style.overflow=""; } }
  var burger = $("#Burger");
  if(burger) burger.addEventListener("click", openMobile);
  if(mnav){
    $all("[data-close-mobile]", mnav).forEach(function(el){ el.addEventListener("click", closeMobile); });
  }
  document.addEventListener("keydown", function(e){ if(e.key==="Escape"){ closeMobile(); if(dd) dd.classList.remove("open"); } });

  var cookie = $("#CookieBanner");
  if(cookie){
    var seen;
    try { seen = localStorage.getItem("vx_cookie_ok"); } catch(e){ seen = null; }
    if(!seen){ cookie.classList.remove("hide"); }
    $all("[data-cookie-dismiss]", cookie).forEach(function(b){
      b.addEventListener("click", function(){
        cookie.classList.add("hide");
        try { localStorage.setItem("vx_cookie_ok","1"); } catch(e){}
      });
    });
  }

  function bindQuickAdd(scope){
    $all("[data-quick-add]", scope).forEach(function(btn){
      if(btn._quickAddBound) return;
      btn._quickAddBound = true;
      btn.addEventListener("click", function(e){
        e.preventDefault(); e.stopPropagation();
        var id = btn.getAttribute("data-variant-id");
        if(!id) return;
        btn.disabled = true; var old = btn.textContent; btn.textContent = "Adding…";
        fetch("/cart/add.js", {
          method:"POST", headers:{ "Content-Type":"application/json", "Accept":"application/json" },
          body: JSON.stringify({ id: id, quantity: 1 })
        }).then(function(r){ return r.json(); })
          .then(function(){ refreshCart(); toast("Added to bag"); })
          .catch(function(){ toast("Sorry, couldn't add that"); })
          .finally(function(){ btn.disabled = false; btn.textContent = old; });
      });
    });
  }
  bindQuickAdd(document);

  var track = $("#GalTrack");
  if(track){
    var slides = $all(".gal-slide", track);
    var thumbs = $all("#GalThumbs img");
    function indexNow(){ return Math.round(track.scrollLeft / track.clientWidth); }
    function goTo(i){
      i = Math.max(0, Math.min(slides.length - 1, i));
      if(slides[i]) track.scrollTo({ left: slides[i].offsetLeft, behavior: "smooth" });
    }
    var prev = $("#GalPrev"), next = $("#GalNext");
    if(prev) prev.addEventListener("click", function(){ goTo(indexNow() - 1); });
    if(next) next.addEventListener("click", function(){ goTo(indexNow() + 1); });
    thumbs.forEach(function(t){
      t.addEventListener("click", function(){ goTo(parseInt(t.getAttribute("data-index"), 10) || 0); });
    });
    var st;
    track.addEventListener("scroll", function(){
      clearTimeout(st);
      st = setTimeout(function(){
        var idx = indexNow();
        thumbs.forEach(function(x, j){ x.classList.toggle("sel", j === idx); });
        if(prev) prev.style.opacity = idx === 0 ? "0.35" : "1";
        if(next) next.style.opacity = idx === slides.length - 1 ? "0.35" : "1";
      }, 70);
    });
  }

  var zoomImgs = $all(".gal-slide img[data-zoom]");
  if(zoomImgs.length){
    var multi = zoomImgs.length > 1;
    var lb = document.createElement("div");
    lb.className = "lightbox";
    lb.innerHTML = '<button type="button" class="lb-close" aria-label="Close">×</button>' +
      (multi ? '<button type="button" class="lb-arrow lb-prev" aria-label="Previous image">‹</button>' +
               '<button type="button" class="lb-arrow lb-next" aria-label="Next image">›</button>' +
               '<span class="lb-count"></span>' : '') +
      '<img alt="">';
    document.body.appendChild(lb);
    var lbImg = $("img", lb);
    var lbPrev = $(".lb-prev", lb), lbNext = $(".lb-next", lb), lbCount = $(".lb-count", lb);
    var lbIndex = 0;
    function showLb(i){
      lbIndex = (i + zoomImgs.length) % zoomImgs.length;
      var img = zoomImgs[lbIndex];
      lbImg.src = img.getAttribute("data-zoom") || img.src;
      lbImg.alt = img.alt || "";
      if(lbCount) lbCount.textContent = (lbIndex + 1) + " / " + zoomImgs.length;
    }
    function openLb(i){
      showLb(i);
      lb.classList.add("open");
      document.body.style.overflow = "hidden";
    }
    function closeLb(){
      lb.classList.remove("open");
      document.body.style.overflow = "";
      lbImg.src = "";
    }
    zoomImgs.forEach(function(img, i){
      img.addEventListener("click", function(){ openLb(i); });
    });
    if(lbPrev) lbPrev.addEventListener("click", function(e){ e.stopPropagation(); showLb(lbIndex - 1); });
    if(lbNext) lbNext.addEventListener("click", function(e){ e.stopPropagation(); showLb(lbIndex + 1); });
    lb.addEventListener("click", function(e){
      if(e.target === lb || e.target === lbImg || e.target.classList.contains("lb-close")) closeLb();
    });
    document.addEventListener("keydown", function(e){
      if(!lb.classList.contains("open")) return;
      if(e.key === "Escape") closeLb();
      if(multi && e.key === "ArrowLeft") showLb(lbIndex - 1);
      if(multi && e.key === "ArrowRight") showLb(lbIndex + 1);
    });
    if(multi){
      var lbTouchX = null;
      lb.addEventListener("touchstart", function(e){ lbTouchX = e.touches[0].clientX; }, { passive: true });
      lb.addEventListener("touchend", function(e){
        if(lbTouchX === null) return;
        var dx = e.changedTouches[0].clientX - lbTouchX;
        lbTouchX = null;
        if(Math.abs(dx) < 40) return;
        dx < 0 ? showLb(lbIndex + 1) : showLb(lbIndex - 1);
      }, { passive: true });
    }
  }

  function bindQtySteppers(scope){
    $all("[data-qty]", scope).forEach(function(box){
      if(box._qtyBound) return;
      box._qtyBound = true;
      var input = $("input", box);
      var minus = $("[data-qty-minus]", box);
      var plus  = $("[data-qty-plus]", box);
      var min = parseInt(input.getAttribute("min") || "1", 10);
      var max = parseInt(input.getAttribute("max") || "9999", 10);
      if(minus) minus.addEventListener("click", function(){ var v=parseInt(input.value||"1",10); if(v>min){ input.value=v-1; input.dispatchEvent(new Event("change")); } });
      if(plus)  plus.addEventListener("click", function(){ var v=parseInt(input.value||"1",10); if(v<max){ input.value=v+1; input.dispatchEvent(new Event("change")); } });
    });
  }
  bindQtySteppers(document);

  var cartWrapEl = $(".cart-wrap");
  if(cartWrapEl){
    var refreshCartSection = function(){
      var base = window.location.pathname;
      var url = base + (base.indexOf("?") > -1 ? "&" : "?") + "section_id=main-cart";
      fetch(url, { headers: { "Accept": "text/html" } })
        .then(function(r){ return r.text(); })
        .then(function(html){
          var doc = new DOMParser().parseFromString(html, "text/html");
          var newWrap = doc.querySelector(".cart-wrap");
          var oldWrap = $(".cart-wrap");
          if(newWrap && oldWrap && oldWrap.parentNode){
            oldWrap.parentNode.replaceChild(newWrap, oldWrap);
            bindQtySteppers(newWrap);
            bindCartLineChange(newWrap);
          }
          refreshCart();
        })
        .catch(function(){ window.location.reload(); });
    };

    var bindCartLineChange = function(scope){
      $all("input[data-line]", scope).forEach(function(input){
        if(input._lineBound) return;
        input._lineBound = true;
        input.addEventListener("change", function(){
          var line = input.getAttribute("data-line");
          var qty = parseInt(input.value, 10);
          if(isNaN(qty) || qty < 0) qty = 0;
          input.disabled = true;
          fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", "Accept": "application/json" },
            body: JSON.stringify({ line: line, quantity: qty })
          }).then(function(r){ return r.json(); })
            .then(function(){ refreshCartSection(); })
            .catch(function(){ toast("Sorry, couldn't update your bag"); input.disabled = false; });
        });
      });
    };

    bindCartLineChange(cartWrapEl);
  }

  var pdpForm = $("#ProductForm");
  if(pdpForm){
    pdpForm.addEventListener("submit", function(e){
      if(window.fetch){
        e.preventDefault();
        var fd = new FormData(pdpForm);
        var btn = $(".add", pdpForm);
        if(btn){ btn.disabled = true; }
        fetch("/cart/add.js", { method:"POST", body: fd, headers:{ "Accept":"application/json" } })
          .then(function(r){ return r.json(); })
          .then(function(){ refreshCart(); toast("Added to bag"); })
          .catch(function(){ toast("Sorry, couldn't add that"); })
          .finally(function(){ if(btn) btn.disabled = false; });
      }
    });
  }

  var pvSelect = $("#ProductVariantSelect");
  var pvData = [];
  var pvDataEl = $("#ProductVariantsData");
  if(pvDataEl){
    try { pvData = JSON.parse(pvDataEl.textContent || "[]"); } catch(e){ pvData = []; }
  }

  var priceCur = $("#PriceCurrent");
  var priceWas = $("#PriceWas");
  var addBtn = $("#AddToBagBtn");
  var stickyPriceEl = $("#StickyBuyPrice");
  var stickyAddBtn = $("#StickyBuyAdd");

  function applyVariant(id){
    var v = null;
    for(var i = 0; i < pvData.length; i++){
      if(String(pvData[i].id) === String(id)){ v = pvData[i]; break; }
    }
    if(!v) return;
    if(priceCur){
      priceCur.textContent = v.price;
      priceCur.classList.toggle("sale", !!v.compareAtPrice);
    }
    if(priceWas){
      if(v.compareAtPrice){ priceWas.textContent = v.compareAtPrice; priceWas.style.display = ""; }
      else { priceWas.style.display = "none"; }
    }
    if(addBtn){
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? "Add To Bag" : "Sold Out";
    }
    if(stickyPriceEl){
      stickyPriceEl.textContent = v.price;
    }
    if(stickyAddBtn){
      stickyAddBtn.disabled = !v.available;
      stickyAddBtn.textContent = v.available ? "Add To Bag" : "Sold Out";
    }
  }

  if(pvSelect){
    pvSelect.addEventListener("change", function(){ applyVariant(pvSelect.value); });
  }

  var stickyBuy = $("#StickyBuy");
  if(stickyBuy){
    if(stickyAddBtn && addBtn){
      stickyAddBtn.addEventListener("click", function(){
        if(!addBtn.disabled) addBtn.click();
      });
    }
    if(addBtn && "IntersectionObserver" in window){
      var stickyObserver = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          stickyBuy.classList.toggle("show", !entry.isIntersecting);
        });
      }, { rootMargin: "0px 0px -15% 0px" });
      stickyObserver.observe(addBtn);
    }
  }

  var fbtSection = $(".fbt");
  if(fbtSection){
    var fbtChecks = $all("[data-fbt-item]", fbtSection);
    var fbtTotalEl = $("#FBTTotal");
    var fbtCountEl = $("#FBTCount");
    var fbtAddBtn = $("#FBTAdd");

    function fbtMoney(cents){
      return "£" + (cents / 100).toFixed(2);
    }

    function fbtUpdate(){
      var total = 0, count = 0;
      fbtChecks.forEach(function(cb){
        if(cb.checked){ total += parseInt(cb.getAttribute("data-price"), 10) || 0; count++; }
      });
      if(fbtTotalEl) fbtTotalEl.textContent = fbtMoney(total);
      if(fbtCountEl) fbtCountEl.textContent = "(" + count + (count === 1 ? " item)" : " items)");
      if(fbtAddBtn) fbtAddBtn.disabled = count === 0;
    }

    fbtChecks.forEach(function(cb){ cb.addEventListener("change", fbtUpdate); });

    if(fbtAddBtn){
      fbtAddBtn.addEventListener("click", function(){
        var items = fbtChecks.filter(function(cb){ return cb.checked; }).map(function(cb){
          return { id: cb.getAttribute("data-variant-id"), quantity: 1 };
        });
        if(!items.length) return;
        fbtAddBtn.disabled = true;
        var old = fbtAddBtn.textContent;
        fbtAddBtn.textContent = "Adding…";
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ items: items })
        }).then(function(r){ return r.json(); })
          .then(function(){ refreshCart(); toast("Added to bag"); })
          .catch(function(){ toast("Sorry, couldn't add those"); })
          .finally(function(){ fbtAddBtn.disabled = false; fbtAddBtn.textContent = old; fbtUpdate(); });
      });
    }

    fbtUpdate();
  }

  var rvDataEl = $("#RVData");
  if(rvDataEl){
    var rvCurrent = null;
    try { rvCurrent = JSON.parse(rvDataEl.textContent || "null"); } catch(e){ rvCurrent = null; }

    if(rvCurrent && rvCurrent.id){
      var rvList = [];
      try { rvList = JSON.parse(localStorage.getItem("vx_recent") || "[]"); } catch(e){ rvList = []; }

      var rvOthers = rvList.filter(function(p){ return p && p.id !== rvCurrent.id; }).slice(0, 4);

      rvList = rvList.filter(function(p){ return p && p.id !== rvCurrent.id; });
      rvList.unshift(rvCurrent);
      if(rvList.length > 12) rvList = rvList.slice(0, 12);
      try { localStorage.setItem("vx_recent", JSON.stringify(rvList)); } catch(e){}

      var rvSection = $("#RecentlyViewed");
      var rvGrid = $("#RVGrid");
      if(rvSection && rvGrid && rvOthers.length){
        rvGrid.innerHTML = "";
        rvOthers.forEach(function(p){
          var a = document.createElement("a");
          a.className = "card";
          a.href = p.url;
          a.innerHTML =
            '<div class="ph"><img class="primary" src="' + p.image + '" alt="' + String(p.title).replace(/"/g,"&quot;") + '" loading="lazy" width="600" height="750"></div>' +
            '<div class="meta">' +
              '<div class="ty">' + p.type + '</div>' +
              '<div class="nm">' + p.title + '</div>' +
              '<div class="pr">' + p.price + (p.isFabric ? ' <span>/ metre</span>' : '') + '</div>' +
            '</div>';
          rvGrid.appendChild(a);
        });
        rvSection.hidden = false;
      }
    }
  }

  var ffQuiz = $("#FFQuiz");
  if(ffQuiz){
    var ffDataEl = $("#FFData");
    var ffProducts = [];
    try { ffProducts = JSON.parse(ffDataEl.textContent || "[]"); } catch(e){ ffProducts = []; }

    var answers = { family: "any", stretch: "any", weight: "any", budget: "any" };
    var steps = $all(".ff-step", ffQuiz);
    var dots = $all(".ff-dot", $("#FFProgress"));
    var backBtn = $("#FFBack");
    var current = 0;

    function showStep(i){
      steps.forEach(function(s, j){ s.hidden = (j !== i); });
      dots.forEach(function(d, j){ d.classList.toggle("on", j <= i); });
      backBtn.hidden = (i === 0);
      current = i;
    }

    steps.forEach(function(step, i){
      $all(".ff-opt", step).forEach(function(btn){
        btn.addEventListener("click", function(){
          var q = $(".ff-opts", step).getAttribute("data-q");
          answers[q] = btn.getAttribute("data-val");
          if(i < steps.length - 1){
            showStep(i + 1);
          } else {
            runQuiz();
          }
        });
      });
    });

    backBtn.addEventListener("click", function(){
      if(current > 0) showStep(current - 1);
    });

    function scoreProduct(p){
      var score = 0;
      var why = [];

      if(answers.family !== "any"){
        if(p.family === answers.family){ score += 3; why.push("right type for the job"); }
      }
      if(answers.stretch !== "any"){
        if(p.stretch === answers.stretch){ score += 2; why.push("matches the stretch you want"); }
        else if(p.stretch === "unknown"){ score += 1; }
      }
      if(answers.weight !== "any"){
        if(p.weight === answers.weight){ score += 2; why.push("right weight"); }
        else if(p.weight === "unknown"){ score += 1; }
      }
      if(answers.budget !== "any"){
        var inBudget = false;
        if(answers.budget === "low")  inBudget = p.priceValue < 4;
        if(answers.budget === "mid")  inBudget = p.priceValue >= 4 && p.priceValue <= 6;
        if(answers.budget === "high") inBudget = p.priceValue > 6;
        if(inBudget){ score += 1; why.push("within budget"); }
        else { score -= 1; }
      }
      return { score: score, why: why };
    }

    function runQuiz(){
      var scored = ffProducts.map(function(p){
        var r = scoreProduct(p);
        return { p: p, score: r.score, why: r.why };
      });
      scored.sort(function(a, b){ return b.score - a.score; });
      var top = scored.slice(0, 6).filter(function(x){ return x.score > -1; });

      ffQuiz.hidden = true;
      var results = $("#FFResults");
      var grid = $("#FFGrid");
      var empty = $("#FFEmpty");
      grid.innerHTML = "";

      if(!top.length){
        empty.hidden = false;
      } else {
        empty.hidden = true;
        top.forEach(function(x){
          var p = x.p;
          var whyText = x.why.length ? x.why.join(" · ") : "worth a look";
          var a = document.createElement("a");
          a.className = "card";
          a.href = p.url;
          a.innerHTML =
            '<div class="ph"><img class="primary" src="' + p.image + '" alt="' + p.title.replace(/"/g,"&quot;") + '" loading="lazy" width="600" height="750"></div>' +
            '<div class="meta">' +
              '<div class="ty">' + p.type + '</div>' +
              '<div class="nm">' + p.title + '</div>' +
              '<div class="pr">' + p.price + ' <span>/ metre</span></div>' +
              '<div class="ff-why">' + whyText + '</div>' +
            '</div>';
          grid.appendChild(a);
        });
      }

      results.hidden = false;
      results.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    var restartBtn = $("#FFRestart");
    if(restartBtn){
      restartBtn.addEventListener("click", function(){
        answers = { family: "any", stretch: "any", weight: "any", budget: "any" };
        $("#FFResults").hidden = true;
        ffQuiz.hidden = false;
        showStep(0);
        ffQuiz.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    }
  }

  var bbGrid = $("#BBGrid");
  if(bbGrid){
    var bbCards = $all("[data-bb-card]", bbGrid);
    var bbBar = $("#BBBar");
    var bbCount = $("#BBCount");
    var bbSaveMsg = $("#BBSaveMsg");
    var bbAdd = $("#BBAdd");
    var selected = [];

    function bbUpdate(){
      bbCount.textContent = selected.length + " of 3";
      bbSaveMsg.textContent = selected.length >= 3 ? "— £1.50 saving applied at checkout" : "— pick " + (3 - selected.length) + " more to save £1.50";
      bbAdd.disabled = selected.length !== 3;
      bbBar.classList.toggle("show", selected.length > 0);
      bbCards.forEach(function(c){
        var id = c.getAttribute("data-variant-id");
        c.classList.toggle("on", selected.indexOf(id) !== -1);
      });
    }

    bbCards.forEach(function(card){
      if(card.disabled) return;
      card.addEventListener("click", function(){
        var id = card.getAttribute("data-variant-id");
        var idx = selected.indexOf(id);
        if(idx !== -1){
          selected.splice(idx, 1);
        } else {
          if(selected.length >= 3) return;
          selected.push(id);
        }
        bbUpdate();
      });
    });

    bbAdd.addEventListener("click", function(){
      if(selected.length !== 3) return;
      bbAdd.disabled = true;
      var old = bbAdd.textContent;
      bbAdd.textContent = "Adding…";
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ items: selected.map(function(id){ return { id: id, quantity: 1 }; }) })
      }).then(function(r){ return r.json(); })
        .then(function(){ window.location.href = "/cart"; })
        .catch(function(){ toast("Sorry, couldn't add the bundle"); bbAdd.disabled = false; bbAdd.textContent = old; });
    });

    bbUpdate();
  }

  /* ---- colour swatch filter (collection pages, covers the whole collection) ---- */
  var collGrid = $(".shop-top .grid");
  if(collGrid){
    var COLOR_MAP = [
      ["off white", "#f5f1e8"], ["ivory", "#f4f0e4"], ["oatmeal", "#cdbfa8"], ["cream", "#f2ecd8"],
      ["dusty rose", "#c98f8f"], ["blush pink", "#e7b8bd"], ["fuchsia pink", "#c2185b"], ["fuchsia", "#c2185b"],
      ["hot pink", "#e0218a"], ["pink", "#f0a8bc"],
      ["denim blue", "#2c4a6e"], ["sky blue", "#8ec6e6"], ["turquoise", "#30c2c2"], ["teal", "#0f8080"],
      ["navy", "#1b2a4a"], ["royal blue", "#1e3fae"], ["blue", "#2f6fbf"],
      ["emerald", "#046a38"], ["sage", "#9caf88"], ["olive", "#6b6b2a"], ["green", "#2f7d4f"],
      ["mustard", "#c99a2e"], ["gold", "#c9a227"], ["yellow", "#e8c93a"],
      ["burgundy", "#6d1f2b"], ["maroon", "#6d1f2b"], ["red", "#c0392b"],
      ["silver grey", "#b8b8b0"], ["silver gray", "#b8b8b0"], ["silver", "#c7c7c2"],
      ["charcoal", "#3a3a3a"], ["grey", "#8b8b86"], ["gray", "#8b8b86"],
      ["khaki", "#8a7b53"], ["beige", "#d8c6a8"], ["tan", "#c8a06a"], ["chocolate", "#4a2e1e"], ["brown", "#5a3d2b"],
      ["lilac", "#c6aee0"], ["lavender", "#c9b8e8"], ["purple", "#6a3d8f"],
      ["orange", "#d9752c"], ["rust", "#a5502a"],
      ["black", "#1c1c1c"], ["white", "#f7f5f0"]
    ];
    function detectColor(title){
      var t = title.toLowerCase();
      var best = null, bestIdx = Infinity;
      COLOR_MAP.forEach(function(entry){
        var idx = t.indexOf(entry[0]);
        if(idx !== -1 && idx < bestIdx){ bestIdx = idx; best = entry; }
      });
      return best;
    }

    var swatchCards = [];
    var found = {};
    var activeColors = {};
    var swatchBar = null;
    var swatchClear = null;
    var loadingLabel = null;

    function applySwatchFilter(){
      var anyActive = Object.keys(activeColors).some(function(k){ return activeColors[k]; });
      swatchCards.forEach(function(card){
        if(!anyActive){
          card.style.display = card.hasAttribute("data-extra-page") ? "none" : "";
          return;
        }
        var k = card.getAttribute("data-swatch-color");
        card.style.display = (k && activeColors[k]) ? "" : "none";
      });
      var pag = $("#CollPagination");
      if(pag) pag.hidden = anyActive;
      var visibleCount = swatchCards.filter(function(c){ return c.style.display !== "none"; }).length;
      var emptyMsg = $(".color-swatches-empty", collGrid.parentNode);
      if(anyActive && visibleCount === 0){
        if(!emptyMsg){
          emptyMsg = document.createElement("div");
          emptyMsg.className = "empty color-swatches-empty";
          emptyMsg.textContent = "No products match that colour.";
          collGrid.parentNode.insertBefore(emptyMsg, collGrid.nextSibling);
        }
      } else if(emptyMsg){
        emptyMsg.remove();
      }
    }

    function addSwatchButton(key){
      var swatch = document.createElement("button");
      swatch.type = "button";
      swatch.className = "color-swatch";
      swatch.style.background = found[key].hex;
      swatch.title = found[key].label.replace(/\b\w/g, function(c){ return c.toUpperCase(); });
      swatch.addEventListener("click", function(){
        activeColors[key] = !activeColors[key];
        swatch.classList.toggle("active", !!activeColors[key]);
        applySwatchFilter();
      });
      swatchBar.insertBefore(swatch, swatchClear);
    }

    function registerCard(card, isExtra){
      var nameEl = $(".nm", card);
      var match = nameEl ? detectColor(nameEl.textContent || "") : null;
      if(isExtra){
        card.setAttribute("data-extra-page", "1");
        card.style.display = "none";
      }
      swatchCards.push(card);
      if(match){
        var key = match[0].replace(/\s+/g, "-");
        card.setAttribute("data-swatch-color", key);
        if(!found[key]){
          found[key] = { hex: match[1], label: match[0], count: 0 };
          if(swatchBar) addSwatchButton(key);
        }
        found[key].count++;
      }
    }

    $all(".card", collGrid).forEach(function(card){ registerCard(card, false); });

    if(Object.keys(found).length > 0){
      swatchBar = document.createElement("div");
      swatchBar.className = "color-swatches";
      var swatchLabel = document.createElement("span");
      swatchLabel.className = "cs-label";
      swatchLabel.textContent = "Colour";
      swatchBar.appendChild(swatchLabel);

      var swatchToggle = document.createElement("button");
      swatchToggle.type = "button";
      swatchToggle.className = "cs-toggle";
      swatchToggle.textContent = "Filter by colour";
      swatchToggle.setAttribute("aria-expanded", "false");
      swatchToggle.addEventListener("click", function(){
        var open = swatchBar.classList.toggle("swatches-open");
        swatchToggle.setAttribute("aria-expanded", open ? "true" : "false");
        swatchToggle.textContent = open ? "Hide colours" : "Filter by colour";
      });
      swatchBar.appendChild(swatchToggle);

      loadingLabel = document.createElement("span");
      loadingLabel.className = "cs-loading";
      swatchBar.appendChild(loadingLabel);

      swatchClear = document.createElement("button");
      swatchClear.type = "button";
      swatchClear.className = "color-swatch-clear";
      swatchClear.textContent = "Clear";
      swatchClear.addEventListener("click", function(){
        activeColors = {};
        $all(".color-swatch", swatchBar).forEach(function(s){ s.classList.remove("active"); });
        applySwatchFilter();
      });
      swatchBar.appendChild(swatchClear);

      Object.keys(found).forEach(function(key){ addSwatchButton(key); });

      var collFilterBar = $("#CollFilters");
      if(collFilterBar && collFilterBar.parentNode){
        collFilterBar.parentNode.insertBefore(swatchBar, collFilterBar.nextSibling);
      } else {
        collGrid.parentNode.insertBefore(swatchBar, collGrid);
      }

      var totalPages = parseInt(collGrid.getAttribute("data-total-pages") || "1", 10);
      if(totalPages > 1){
        loadingLabel.textContent = "Loading full colour range…";
        var baseUrl = new URL(window.location.href);
        var fetches = [];
        for(var p = 2; p <= totalPages; p++){
          (function(pageNum){
            var u = new URL(baseUrl.href);
            u.searchParams.set("page", pageNum);
            fetches.push(
              fetch(u.toString(), { headers: { "Accept": "text/html" } })
                .then(function(r){ return r.text(); })
                .then(function(html){
                  var doc = new DOMParser().parseFromString(html, "text/html");
                  var pageCards = $all(".shop-top .grid .card", doc);
                  pageCards.forEach(function(card){
                    collGrid.appendChild(card);
                    registerCard(card, true);
                    bindQuickAdd(card);
                  });
                })
                .catch(function(){})
            );
          })(p);
        }
        Promise.all(fetches).then(function(){
          loadingLabel.textContent = "";
        });
      }
    }
  }

  /* ---- initial cart count sync ---- */
  refreshCart();
})();
